import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
} from "../../Helpers/typography";

//Material Icons
import { Add } from "@mui/icons-material";
import UserRow from "./UserRow";

//Local components
import NewUserDrawer from "../drawers/NewUserDrawer";

export default function RegisteredUsersList({ users = [], getUsers }) {
  // ==========>Component States<==========
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for open add-user drawer
  const [openUserDrawer, setOpenUserDrawer] = useState(false)

  // ==========> Component Functions <==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };
  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Grid container>
      <NewUserDrawer open={openUserDrawer} setOpen={setOpenUserDrawer}/>
      <Grid item xs={12}>
        <Card raised>
          <Grid container sx={{ padding: "15px" }} spacing={1}>
            <Grid item xs={12}>
              {typographyForSubtitles("Usuarios Registrados", "secondary")}
            </Grid>
            <Grid item xs={12}>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                onClick={()=>{setOpenUserDrawer(true)}}
              >
                Agregar nuevo usuario
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="users-table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Nombre",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Fecha nacimiento",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Email",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Posición",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Fecha de ingreso",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Vacaciones disponibles",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Rol",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {typographyForCustomizedFontSize(
                          "Acciones",
                          "11px",
                          null,
                          "bold"
                        )}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users
                      .sort((a, b) => {
                        if (a.user < b.user) return -1;
                        if (a.user > b.user) return 1;
                        return 0;
                      })
                      .map((user) => (
                        <UserRow key={`${user.userId}`} user={user} getUsers={getUsers}/>
                      ))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={users.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage="Filas"
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
